import { ApiResponse, getData } from "./Apis";

export type EmailLogContainerModel = {
    emails: EmailLogModel[],
    showMailto: boolean,
}

export type EmailLogModel = {
    Subject: string,
    Body: string,
    BodySignature: string,
    FromAddress: string,
    DateAndTime: Date,
    Sender: string,
    SenderProxyAddress: string
}

export async function API_EmailLogs(): Promise<ApiResponse<EmailLogContainerModel>> {
    return await getData<ApiResponse<EmailLogContainerModel>>("webapi/candidate/EmailLog/GetAll");
}